module.exports = __webpack_public_path__ + "static/media/icon-logo.ba0d8f02.svg";